import { isAgentPortal } from "js/utilities";
import { getTypeOfPolicy } from "js/utilities";

export const getSlideTitle = (policyMessages, policies) => {
  const currentMessagePolicy = policies.find(
    (policy) => policy.contractID === policyMessages.policy
  );

  const titlePrefix =
    getTypeOfPolicy(currentMessagePolicy.product.type) === "annuity"
      ? "Contract"
      : "Policy";

  return `${
    isAgentPortal() ? "Customer Alerts: " : ""
  }${titlePrefix} Number - ${policyMessages?.memberID}`;
};
